import * as React from 'react';
import CodeField from '../ts/CodeField';
import * as Utilities from '../ts/Utilities';

import { IGlob } from '../../application/ts/Glob';
import { IValuesCollection } from '../ts/appTheme';

function PasteTargetDialog(props: {
    setConfirmValueGetter(getConfirmValue);
    unsetConfirmValueGetter?();

    options: {
        theme: IValuesCollection;
    };
    glob: IGlob;
}) {
    const [value, setValue] = React.useState(() => props.glob.AppStore.getFromLocalStorage('pdc_clipboard_data'));

    React.useEffect(() => {
        const obj = props.setConfirmValueGetter(() => {
            return value;
        });

        return () => {
            if (typeof props.unsetConfirmValueGetter === 'function') {
                props.unsetConfirmValueGetter();
            }
        };
    }, [value]);

    const handleOnDataChange = (value: string) => {
        setValue(value);
    };

    const Component = CodeField.EditComponent;
    const theme = props.options?.theme || {};

    return (
        <div className="export-params">
            <div>
                <p>
                    {
                        'If security settings of your browser prevent the editor from access to your clipboard data directly, paste inside field below by the keyboard (Ctrl/Cmd+V) and press Paste.'
                    }
                </p>
            </div>
            <div>
                <Component
                    value={value}
                    wordWrap={true}
                    setFocus={true}
                    theme={theme}
                    initialHeight={420}
                    showFuncList={false}
                    showAttrList={true}
                    putAttrAsArray={false}
                    dataSourceID={Utilities.getDataSourceID(value)}
                    glob={props.glob}
                    onChange={handleOnDataChange}
                />
            </div>
        </div>
    );
}

export function PasteButton(props: {
    theme: IValuesCollection;
    dialogTitle?: string;
    glob: IGlob;
    onPaste(value: string): void;
}) {
    const handleOnPasteClick = (e) => {
        props.glob.DialogActions.createDialog(
            props.dialogTitle || 'Paste Widget',
            null,
            (data) => {
                if (props.onPaste != null) {
                    props.onPaste(data);
                }
            },
            () => {},
            () => {},
            'custom',
            {
                deny: false,
                confirmTitle: 'Paste',
                componentOptions: {
                    theme: props.theme
                },
                resizable: true,
                minHeight: 210,

                Component: PasteTargetDialog
            }
        );
    };

    return (
        <button className="btn-paste-from-clipboard btn btn-default" onClick={handleOnPasteClick}>
            <span className="glyphicon glyphicon-paste" />
            {'Paste'}
        </button>
    );
}
